import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

export enum ResponseType {
  Success = 1,
  Validation = 2,
  Error = 3,
  Security = 4
}

@Injectable({
  providedIn: 'root'
})
export class ResponseHandlerService {

  constructor(
    private toastr: ToastrService,
    private router: Router
  ) { }

  handleResponse(
    response: any,
    successRoute?: string,
    successMessage?: string
  ): boolean {

    const message = response?.message || '';

    switch (response?.responseStatus) {

      case ResponseType.Success:

        this.toastr.success(
          successMessage || message || 'Operation completed successfully'
        );

        if (successRoute) {
          this.router.navigate([successRoute]);
        }

        return true;

      case ResponseType.Validation:

        this.toastr.warning(
          message || 'Validation failed'
        );

        return false;

      case ResponseType.Error:

        this.toastr.error(
          message || 'An error occurred'
        );

        return false;

      case ResponseType.Security:

        this.toastr.error(
          message || 'Access denied'
        );

        return false;

      default:

        this.toastr.error(
          message || 'Unexpected response received'
        );

        return false;
    }
  }

  handleHttpError(error: any): void {

    const message =
      error?.error?.message ||
      error?.message ||
      'Server error occurred';

    this.toastr.error(message);

    console.error('API Error:', error);
  }

  showValidation(message: string): void {
    this.toastr.error(message);
  }

  showSuccess(message: string): void {
    this.toastr.success(message);
  }

  showError(message: string): void {
    this.toastr.error(message);
  }
}
